import backend from "../../utils/backend";
import { GET_AUTHOR, GET_AUTHOR_SUCCESS, GET_AUTHOR_ERROR, GET_STORIES_STREAM, GET_STORIES_STREAM_SUCCESS, GET_STORIES_STREAM_UPDATE, GET_STORIES_STREAM_ERROR } from "../../constants/actionTypes";

export var getAuthor = function getAuthor(username) {
  return function (dispatch) {
    dispatch({
      type: GET_AUTHOR
    });

    return backend.request({
      method: "GET",
      url: "/author/" + username + "/"
    }).then(function (response) {
      dispatch({
        type: GET_AUTHOR_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: GET_AUTHOR_ERROR,
        payload: err
      });
    });
  };
};

export var getAuthorStories = function getAuthorStories(username, params) {
  var appendResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: GET_STORIES_STREAM
      });
    }

    return backend.request({
      method: "GET",
      url: "/author/" + username + "/stories/",
      params: params
    }).then(function (response) {
      dispatch({
        type: appendResults ? GET_STORIES_STREAM_UPDATE : GET_STORIES_STREAM_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: GET_STORIES_STREAM_ERROR,
        payload: {
          handleError: true,
          error: err
        }
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/author/actions/author.js